export const ObjectMapHelper = {
    MapDto
}

function MapDto(fromDto,toDto){
    Object.keys(fromDto).map(function(key){
        if(key in toDto){
            toDto[key] = fromDto[key]
        }
    })
    return toDto;
}